import { tooltipLegacyDriverFactory as tooltipDriverFactory } from '../Tooltip/Tooltip.driver';
import { linearProgressBarDriverFactory as coreLinearProgressBarDriverFactory } from './LinearProgressBarCore/LinearProgressBarCore.driver';
import { dataHooks } from './constants';

const linearProgressBarDriverFactory = ({ element, eventTrigger, wrapper }) => {
  const getElementByDataHook = dataHook =>
    element.querySelector(`[data-hook='${dataHook}']`);
  const createTooltipDriver = () =>
    tooltipDriverFactory({
      element: getElementByDataHook(dataHooks.tooltip),
      eventTrigger,
    });

  const coreProgressBarDriver = coreLinearProgressBarDriverFactory({
    element,
    wrapper,
    eventTrigger,
  });

  return {
    ...coreProgressBarDriver,
    isErrorIconShown: () => !!getElementByDataHook(dataHooks.errorIcon),
    isSuccessIconShown: () => !!getElementByDataHook(dataHooks.successIcon),
    getTooltipErrorMessage: () => {
      const tooltipDriver = createTooltipDriver();
      return tooltipDriver.getTooltipText();
    },
    getSkin: () => element.getAttribute('data-skin'),
  };
};

export default linearProgressBarDriverFactory;
